<template lang="pug">
  include ./../../mixins
  +b.cabinet-modal
    +e.close(
      @click.prevent="$emit('close')"
    )
      +b.icon--type_close
    +b.bg--white.pa--f_md.--f_lg-lg
      GmapMap(
        ref='gmapmap',
        :options='mapOptions',
        :center='center',
        :zoom='zoom',
        @click="getPostcodeHandler"
      )
</template>

<script>
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'
import { eventBus } from '@/js/eventBus'

export default {
  name: 'GoogleMapModal',
  mixins: [
    ToggleModalMixin,
  ],
  created() {
    this.getCurrentLocationHandler()
  },
  data() {
    return {
      mapOptions: {
        fullscreenControl: false,
        streetViewControl: false,
        disableDefaultUi: false,
        mapTypeControl: false,
        rotateControl: false,
        scaleControl: false,
        zoomControl: true,
      },
      center: {
        lng: 0,
        lat: 0,
      },
      zoom: 15,
    }
  },
  methods: {
    setCurrentPosition(position) {
      console.log('position', position)
      let lng = position.coords.longitude
      let lat = position.coords.latitude
      let key = window.googleApiKey
      let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${key}`

      axios.get(url).then(response => {
        console.log('response', response)
        let results = response.data.results
        let addressComponents = results[0]['address_components']

        addressComponents.forEach(el => {
          if (el.types.includes('postal_code')) {
            console.log('qweqweqwe', el['long_name'])
            eventBus.$emit('postcode:update', el['long_name'])
            this.$emit('close')
          }
        })
      })
    },
    setCurrentCenterPosition(position) {
      this.center.lng = position.coords.longitude
      this.center.lat = position.coords.latitude
    },
    getCurrentLocationHandler() {
      console.log(navigator.geolocation)
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.setCurrentCenterPosition
        )
      } else {
        this.toggleToster(
          'Geolocation is not supported.'
        )
      }
    },
    getPostcodeHandler(e) {
      const position = {
        coords: {
          longitude: e.latLng.lng(),
          latitude: e.latLng.lat(),
        }
      }
      this.setCurrentPosition(
        position
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/GoogleMapModal.vue